export default function noop() {}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-geo/src/noop.js
// module id = 22
// module chunks = 0